export enum TaxRateApplyOn {
    FEE_REBATE = 'Fee/Rebate',
    PRINCIPLE = 'Principle'
}
